import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map, Observable, tap } from 'rxjs';
import { Evenement } from '../models/evenement.class';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private http: HttpClient = inject(HttpClient);
  // headers: HttpHeaders = new HttpHeaders().set('Authorization', `Bearer ${environment.API_TOKEN}`)

  /**
   * Construit l'URL complète pour une image Strapi
   * @param url L'URL relative de l'image depuis Strapi
   * @returns L'URL complète vers l'image
   */
  getImageUrl(url: string): string {
    if (!url) return '';
    return url.startsWith('http') ? url : `${environment.API_URL}${url}`;
  }


  getArticles(): Observable<any[]> {
    const url: string = `${environment.API_URL}/api/articles`;
    return this.http.get<any[]>(url)
  }

  getArticle(id: string): Observable<any> {
    const url: string = `${environment.API_URL}/api/articles/${id}`;
    return this.http.get<any>(url)
  }


  getAteliers(): Observable<any[]> {
    const url: string = `${environment.API_URL}/api/ateliers`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.data)
    )
  }

  getAteliersFromPresationType(prestationId: string): Observable<any[]> {
    const url: string = `${environment.API_URL}/api/type-d-ateliers/?filters[type_de_prestation][documentId][$eq]=${prestationId}&populate=*`;
    return this.http.get<any[]>(url).pipe(
      map((response: any) => response.data)
    )
  }

  getAterlier(uid: string): Observable<any> {
    const url: string = `${environment.API_URL}/api/type-d-ateliers/${uid}?populate=*`;
    return this.http.get<any>(url).pipe(
      map((response: any) => response.data
      ))
  }

  getTypesAteliers(): Observable<any[]> {
    const url: string = `${environment.API_URL}/api/type-d-ateliers`;
    const params: HttpParams = new HttpParams().set('populate', '*');
    return this.http.get<any>(url, { params }).pipe(
      // tap(response => console.log('Types d\'ateliers response:', response)),
      map((response: any) => response.data)
    )
  }

  getTypesDePrestations(): Observable<any[]> {
    const url: string = `${environment.API_URL}/api/type-de-prestations`;
    const params: HttpParams = new HttpParams().set('populate', '*');
    return this.http.get<any>(url, { params }).pipe(
      // tap(response => console.log('Types de prestations response:', response)),
      map((response: any) => response.data)
    )
  }

  getTypeDePrestation(prestationId: string): Observable<any[]> {
    const url: string = `${environment.API_URL}/api/type-de-prestations/${prestationId}`;
    const params: HttpParams = new HttpParams().set('populate', '*');
    return this.http.get<any>(url, { params }).pipe(
      // tap(response => console.log('Types de prestations response:', response)),
      map((response: any) => response.data)
    )
  }

  getEvenements(): Observable<Evenement[]> {
    const url: string = `${environment.API_URL}/api/evenements/`;
    const params: HttpParams = new HttpParams()
      .set('populate[lieu]', 'true')
      .set('populate[tranche_d_ages]', 'true')
      .set('populate[type_d_atelier][populate][gallery]', 'true')
      .set('populate[type_d_atelier][populate][themes]', 'true')
      .set('populate[type_d_atelier][populate][type_de_prestation]', 'true');
    return this.http.get<any>(url, { params }).pipe(
      map((response: any) => {
        const data = response.data;
        return data.map((item: any) => new Evenement(item));
      })
    )
  }

  getEvenement(evenementId: string): Observable<Evenement> {
    const url: string = `${environment.API_URL}/api/evenements/${evenementId}`;
    const params: HttpParams = new HttpParams()
      .set('populate[lieu]', 'true')
      .set('populate[tranche_d_ages]', 'true')
      .set('populate[type_d_atelier][populate][gallery]', 'true')
      .set('populate[type_d_atelier][populate][themes]', 'true')
      .set('populate[type_d_atelier][populate][type_de_prestation]', 'true');
    return this.http.get<any>(url, { params }).pipe(
      tap(response => console.log('Evenement response:', response)),
      map((response: any) => {
        const item = response.data;
        return new Evenement(item);
      })
    )
  }


  getEvenementsFromAtelier(atelierId: string): Observable<Evenement[]> {
        const url: string = `${environment.API_URL}/api/evenements/`;
        const params: HttpParams = new HttpParams()
          .set('filters[type_d_atelier][documentId][$eq]', atelierId)
          .set('populate[lieu]', 'true')
          .set('populate[tranche_d_ages]', 'true')
          .set('populate[type_d_atelier][populate][gallery]', 'true')
          .set('populate[type_d_atelier][populate][themes]', 'true')
          .set('populate[type_d_atelier][populate][type_de_prestation]', 'true');
        return this.http.get<any>(url, { params }).pipe(
          map((response: any) => {
            const data = response.data;
            return data.map((item: any) => new Evenement(item));
          })
        )
  }

}
